/**
 * @typedef {Object} FileType
 * @property {string} key - API key for file type
 * @property {string} label - Display label
 * @property {string} description - Help text description
 */

/**
 * Zone upload file types
 * @type {Object.<string, FileType>}
 */
export const FILE_TYPES = {
  ROOM_TO_ZONE: {
    key: "room_to_zone",
    label: "Room to Zone Alignment",
    description: "Contractor-populated mapping file"
  },
  SPACE_INVENTORY: {
    key: "space_inventory",
    label: "Space Inventory",
    description: "School's space and room data"
  }
}

/**
 * Allowed file extensions for upload
 * @type {string[]}
 */
export const ALLOWED_EXTENSIONS = [".csv", ".xlsx", ".xls"]

/**
 * Maximum file size in bytes (10 MB)
 * @type {number}
 */
export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024

/**
 * Maximum file size in megabytes
 * @type {number}
 */
export const MAX_FILE_SIZE_MB = 10

/**
 * Accept string for file input
 * @type {string}
 */
export const ACCEPT_STRING = ".csv,.xlsx,.xls"
